import React from 'react';

import UserFilter from 'components/Filters/UserFilter';

import { MultiSelect } from '@gogame/components';
import { Filter, useFiltersStateManager } from '@gogame/filters';

import {
  FILTER_PERIOD,
  FILTER_STATUSES,
  FILTER_TYPES,
  FILTER_AFFILIATES,
  FILTER_APPLICATIONS,
  FILTER_COST_MODELS,
  FILTER_COUNTRIES,
  FILTER_LABELS,
  FILTER_NETWORKS,
  FILTER_OWNERS,
  FILTER_PARTNER_CAMPAIGNS,
  FILTER_PLATFORMS,
  FILTER_PROMO_CODES,
  FILTER_DEPENDENCIES,
  FILTER_ACTIVITY_TYPE,
  FILTER_CPE_EVENTS,
  FILTER_FRAUD_PROTECTIONS,
} from 'scenes/Campaigns/constants';
import {
  loadFilterStatuses,
  loadFilterTypes,
  loadFilterAffiliates,
  loadFilterApplications,
  loadFilterFraudProtections,
  loadFilterNetworks,
  loadFilterOwners,
  loadFilterPartnerCampaignOwners,
  loadFilterPartnerCampaigns,
  loadFilterPlatforms,
  loadFilterPromoCodes,
  loadFilterCostModels,
  loadFilterCountries,
  loadFilterLabels,
  loadActivityTypes,
  loadCostModelsEventsFilter,
  loadFilterParentCampaignsOwners,
} from 'scenes/Campaigns/sources/filters';

import { CPE_ID } from 'scenes/Campaigns/components/CostModel';

export const Period = (props) => (
  <Filter.DateRangePicker
    title={'Period'}
    placeholder={'All'}
    name={FILTER_PERIOD}
    {...props}
  />
);

export const CampaignType = (props) => (
  <Filter.MultiSelect
    title={'Campaign Types'}
    placeholder={'All'}
    name={FILTER_TYPES}
    variant={'outlined'}
    source={loadFilterTypes}
    withAll={false}
    {...props}
  />
);

export const ActivityType = (props) => (
  <Filter.MultiSelect
    title={'Track RE'}
    placeholder={'All'}
    name={FILTER_ACTIVITY_TYPE}
    variant={'outlined'}
    source={loadActivityTypes}
    withAll={false}
    {...props}
  />
);

export const Affiliates = (props) => (
  <Filter.MultiSelect
    title={'Affiliates'}
    placeholder={'All'}
    name={FILTER_AFFILIATES}
    variant={'outlined'}
    source={loadFilterAffiliates}
    depends={FILTER_DEPENDENCIES[FILTER_AFFILIATES]}
    {...props}
  />
);

export const Applications = (props) => (
  <Filter.MultiSelect
    title={'Applications'}
    placeholder={'All'}
    name={FILTER_APPLICATIONS}
    variant={'outlined'}
    source={loadFilterApplications}
    {...props}
  />
);

export const CostModels = (props) => (
  <Filter
    title={'Cost Models'}
    name={FILTER_COST_MODELS}
    variant={'outlined'}
    source={loadFilterCostModels}
    {...props}
    renderComponent={({
      label,
      value,
      options,
      loading,
      pending,
      onFocus,
      error,
      onChangeMultiple,
    }) => {
      return (
        <MultiSelect
          data-cy={FILTER_COST_MODELS}
          label={label}
          value={value}
          options={options}
          loading={loading}
          withAll={true}
          placeholder={'All'}
          displayPlaceholder={true}
          error={error}
          onFocus={onFocus}
          disabled={pending}
          onChange={(e, value) => {
            onChangeMultiple(e, {
              [FILTER_COST_MODELS]: value,
              ...(value?.includes(CPE_ID) ? null : { [FILTER_CPE_EVENTS]: [] }),
            });
          }}
        />
      );
    }}
  />
);

export const CPEEvent = (props) => {
  const { getFilterValue } = useFiltersStateManager();

  return (
    <Filter.MultiSelect
      title={'CPE Events'}
      placeholder={'All'}
      name={FILTER_CPE_EVENTS}
      variant={'outlined'}
      source={loadCostModelsEventsFilter}
      disabled={!getFilterValue(FILTER_COST_MODELS)?.includes(CPE_ID)}
      depends={FILTER_DEPENDENCIES[FILTER_CPE_EVENTS]}
      {...props}
    />
  );
};

export const Countries = (props) => (
  <Filter.MultiSelect
    title={'Countries'}
    placeholder={'All'}
    name={FILTER_COUNTRIES}
    variant={'outlined'}
    source={loadFilterCountries}
    {...props}
  />
);

export const FraudProtection = (props) => (
  <Filter.MultiSelect
    title={'Fraud protections'}
    placeholder={'All'}
    name={FILTER_FRAUD_PROTECTIONS}
    variant={'outlined'}
    source={loadFilterFraudProtections}
    depends={FILTER_DEPENDENCIES[FILTER_FRAUD_PROTECTIONS]}
    {...props}
  />
);

export const Labels = (props) => (
  <Filter.MultiSelect
    title={'Labels'}
    placeholder={'All'}
    name={FILTER_LABELS}
    variant={'outlined'}
    source={loadFilterLabels}
    {...props}
  />
);

export const Networks = (props) => (
  <Filter.MultiSelect
    title={'Networks'}
    placeholder={'All'}
    name={FILTER_NETWORKS}
    variant={'outlined'}
    source={loadFilterNetworks}
    depends={FILTER_DEPENDENCIES[FILTER_NETWORKS]}
    {...props}
  />
);

export const Owners = (props) => (
  <UserFilter
    title={'Owners'}
    placeholder={'All'}
    name={FILTER_OWNERS}
    variant={'outlined'}
    source={loadFilterOwners}
    {...props}
  />
);

export const ParentCampaignOwners = (props) => (
  <UserFilter
    title={'Owners'}
    placeholder={'All'}
    name={FILTER_OWNERS}
    variant={'outlined'}
    source={loadFilterParentCampaignsOwners}
    {...props}
  />
);

export const PartnerCampaignId = (props) => (
  <Filter.Select
    title={'Partner Campaign ID'}
    placeholder={'All'}
    name={FILTER_PARTNER_CAMPAIGNS}
    variant={'outlined'}
    source={loadFilterPartnerCampaigns}
    {...props}
  />
);

export const Platforms = (props) => (
  <Filter.MultiSelect
    title={'Platforms'}
    placeholder={'All'}
    name={FILTER_PLATFORMS}
    variant={'outlined'}
    source={loadFilterPlatforms}
    depends={FILTER_DEPENDENCIES[FILTER_PLATFORMS]}
    {...props}
  />
);

export const PromoCodes = (props) => (
  <Filter.Select
    title={'Promo Codes'}
    placeholder={'All'}
    name={FILTER_PROMO_CODES}
    variant={'outlined'}
    source={loadFilterPromoCodes}
    {...props}
  />
);

export const Statuses = (props) => (
  <Filter.MultiSelect
    title={'Statuses'}
    placeholder={'All'}
    name={FILTER_STATUSES}
    variant={'outlined'}
    source={loadFilterStatuses}
    withAll={false}
    {...props}
  />
);
